<template>
  <div>
    <img class="bg2" src="../assets/bg2.png"/>
    <img class="bg6" src="../assets/bg6.png"/>
    <img class="bg4" src="../assets/bg4.png"/>
    <div>
      <div class="content">
        <div class="state1">
          <div class="state2" v-if="state!==2">
            <div>
              <img src="../assets/bg3.png"/>
              <img src="../assets/bg5.png"/>
            </div>
            <img src="../assets/bg1.png"/>
          </div>
          <div class="state3" v-if="state===2">
            <img src="../assets/bg7.jpg"/>
            <img @click="jieshuo" src="../assets/bg8.png"/>
          </div>
          <div class="loginCard" v-if="state===0">
            <div>
              <img src="../assets/icon6.png"/>
              <span>23420908人已深度排查,了解信用风险提前预测…</span>
            </div>
            <input v-if="isLogin" v-model="realname" placeholder="请输入姓名" type="" name="" id="" value=""/>
            <input v-if="isLogin" v-model="cert_no" placeholder="请输入您的身份证号码" type="" name="" id=""
                   value=""/>
            <input v-if="!isLogin" v-model="account" type="" placeholder="请输入手机号码" name="" id="" value=""/>
            <div v-if="!isLogin" >
              <!-- <input type="" v-model="verifycode" placeholder="请输入验证码" name="" id="" value=""/>
              <p class="pointer" @click="getCode">{{ timeText }}</p> -->
            </div>
            <div>
              <span>提交即视您已同意</span>
              <span>《数据服务协议》</span>
            </div>
            <div class="pointer" @click="login">
              <div>78%用户已查</div>
              <span>
								立即查看
							</span>
              <img src="../assets/icon7.png"/>
            </div>
          </div>
          <div class="loginCard" v-if="state===1">
            <img src="../assets/scor.gif" style="width: 100%;height: 100%;"/>
          </div>
          <div v-if="state===2" class="payCard">
            <div>
              <img src="../assets/icon6.png"/>
              <span>23420908人已深度排查,了解信用风险提前预测…</span>
            </div>
            <div>
              <img src="../assets/icon8.png"/>
              <span>您的报告已扫描完成</span>
            </div>
            <div>立即扫码,解锁报告,合理优化个人风险</div>
            <div>
              <div ref="qrCode" id="qrCode"/>
              <div>
                <div class="pointer" :style="payType===0?'border-color:#3889FF':''" @click="aliPay">
                  <img src="../assets/alipay.png"/>
                  <span>支付宝支付</span>
                </div>
                <!--                <div class="pointer" :style="payType===1?'border-color:#3889FF':''" @click="wxPay">-->
                <!--                  <img src="../assets/wx.png"/>-->
                <!--                  <span>微信支付</span>-->
                <!--                </div>-->
              </div>
            </div>
            <div @click="queryInfo" class="pointer">
              查看报告
            </div>
            <div class="pointer" @click="historyRecord">历史记录</div>
          </div>
        </div>
      </div>
      <div class="introduce">
        <div>
          <img src="../assets/icon5.png"/>
          <div>
            <p>权威认证</p>
            <p>信息安全管理体系</p>
          </div>
        </div>
        <div>
          <img src="../assets/icon1.png"/>
          <div>
            <p>隐私安全</p>
            <p>银行级数据加密,安全运营18年</p>
          </div>
        </div>
        <div>
          <img src="../assets/icon2.png"/>
          <div>
            <p>极速查询</p>
            <p>一键生成个人数据报告</p>
          </div>
        </div>
        <div>
          <img src="../assets/icon3.png"/>
          <div>
            <p>多维数据</p>
            <p>包含8大模块,40+项权威数据</p>
          </div>
        </div>
        <div>
          <img src="../assets/icon4.png"/>
          <div>
            <p>解读建议</p>
            <p>专业解读个人失信信息</p>
          </div>
        </div>
      </div>
      <div class="icp">
        <span>(温馨提示:本报告非央行征信报告)</span>
        <!-- <div>
            <span>关于我们</span>
            <span>联系我们</span>
        </div> -->
       <span @click="icp" class="pointer">无锡信知行信息技术有限公司 备案号:苏ICP备2023004907号-1</span>
       <span class="pointer">电话号码:0510-57338965 公司地址:无锡市梁溪区锡惠园22-2-222</span>
       <span>严格按照相关法律法规及监管单位的操作要求,合法合规经营,若您对查询结果有异议,发起异议处理</span>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'

const storage = window.sessionStorage;
export default {
  name: 'Login',
  data() {
    return {
      isLogin: false,
      account: '',
      verifycode: '',
      timeText: '获取验证码',
      time: 60,
      state: 2,
      cert_no: '',
      realname: '',
      token: '',
      payType: 0,
      orderId: '',
      wxInfo: null,
      aliPayInfo: null,
      intervalId: ""
    }
  },
  created() {
    this.token = storage.getItem("token");
    this.orderId = this.$route.query.orderId;
    this.aliPay();
    let that = this;
    this.intervalId = setInterval(function () {
      that.$http.post("port/search/getOneSearchOrder", {
        order_id: that.orderId,
        token: that.token,
        bd_vid:storage.getItem("bd_vid")
      }).then((response) => {
        if (response.data.data.sOrder.is_pay === 1) {
          clearInterval(that.intervalId);
		  //360回传s
		  (function(w,n){
		      w[n] = typeof w[n] === 'function' ? w[n]:function(){
		      (w[n].c = w[n].c || []).push(arguments);
		      }
		  
		      _qha('send', {
		       et: 31,
		       order: [{
		      id:'' + that.orderId,/* 订单号, 必填项*/
		      itemId:'' + that.orderId,/*商品订单，商品ID为必填项*/
		         vendorId:'',/*供应商id*/
		         orderType:'0', /* 常量，请勿修改*/
		         price: '' + that.price,/* 订单总价*/
		         state: ''/* 订单状态*/
		       }]
		      });
		    })(window, '_qha');
		  
		  //360回传e
          that.intervalId = null;
          that.$confirm('支付成功，您的报告已生成！', '', {
            confirmButtonText: '立即查看',
            cancelButtonText: '取消',
            type: 'success'
          }).then(() => {
            window.open("https://zxh1.xinzxing.cn/index/#/pages/info/info?id=" + that.orderId + "&token=" + that.token, "_blank");
          })
        }
      })
    }, 5000);
  },
  destroyed() {
    if (this.intervalId != null) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  },
  mounted() {
    document.querySelector('body').setAttribute('style', 'background-color:#1A76FE')
  },
  beforeDestroy() {
    document.querySelector('body').removeAttribute('style')
  },
  methods: {
    login() {
      if (!this.isLogin) {
        this.$http.post("port/login/zhuceorloginByYanzhengma", {
          account: this.account,
          verifycode: this.verifycode,
          bd_vid:storage.getItem("bd_vid")
        }).then((response) => {
          if (response.data.code === 0) {
            this.$message({
              message: response.data.msg,
              type: 'error'
            });
          } else {
            storage.setItem("mid", response.data.data.mid);
            storage.setItem("token", response.data.data.token);
            this.token = response.data.data.token;
            this.isLogin = true;
            this.timeText = '获取验证码';
            this.time = 60;
          }
        })
      } else {
        let that = this;
        this.$http.post("port/search/sendSearchOrderTwo", {
          cert_no: this.cert_no,
          realname: this.realname,
          token: this.token,
          bd_vid:storage.getItem("bd_vid"),
          ctype:2,
		  baidu360:2
        }).then((response) => {
          if (response.data.code === 0) {
            this.$message({
              message: response.data.msg,
              type: 'error'
            });
          } else {
            this.orderId = response.data.data.sOrder.id;
            that.state = 1;
            setTimeout(function () {
              that.state = 2;
              that.aliPay();
            }, 5000);
          }
        })
      }
    },
    getCode() {
      if (this.time !== 60) {
        return;
      }
      let that = this;
      this.$http.post("port/login/verifycodeZhengxin", {
        mobile: this.account,
        temp: 'sms_reg',
        bd_vid:storage.getItem("bd_vid")
      }).then((response) => {
        if (response.data.code === 0) {
          this.$message({
            message: response.data.msg,
            type: 'error'
          });
        } else {
          var Interval = setInterval(res => {
            that.time--;
            if (that.time === 0) {
              that.timeText = '获取验证码';
              that.time = 60;
              clearInterval(Interval);
            } else {
              that.timeText = that.time + 's';
            }
          }, 1000);
        }
      })
    },
    aliPay() {
      this.payType = 0;
      if (this.aliPayInfo != null) {
        this.qrCode(this.aliPayInfo);
        return
      }
      this.$http.post("port/ali_pay/index_wap", {
        order_id: this.orderId,
        mid: storage.getItem("mid"),
        token: this.token,
        pc: 1,
        bd_vid:storage.getItem("bd_vid")
      }).then((response) => {
        if (response.data.code === 0) {
          this.$message({
            message: response.data.msg,
            type: 'error'
          });
        } else {
          this.aliPayInfo = response.data.qr_code;
          this.qrCode(this.aliPayInfo);
        }
      })
    },
    wxPay() {
      this.payType = 1;
      if (this.wxInfo != null) {
        this.qrCode(this.wxInfo);
        return
      }
      this.$http.post("port/weixin_pay/index", {
        order_id: this.orderId,
        mid: storage.getItem("mid"),
        token: this.token,
        pc: 1,
        bd_vid:storage.getItem("bd_vid")
      }).then((response) => {
        if (response.data.code === 0) {
          this.$message({
            message: response.data.msg,
            type: 'error'
          });
        } else {
          this.wxInfo = response.data.code_url;
          this.qrCode(this.wxInfo);
        }
      })
    },
    qrCode(text) {
      this.$refs.qrCode.innerHTML = '';//清除上一次生成的二维码，防止刷新生成多个二维码
      new QRCode('qrCode', {
        width: 120,//二维码宽度
        height: 120,//二维码高度
        text: text, // 二维码内容
        colorDark: "#000",
        colorLight: "#fff",
      })
    },
    queryInfo() {
      this.$http.post("port/search/getOneSearchOrder", {
        order_id: this.orderId,
        token: this.token,
        bd_vid:storage.getItem("bd_vid")
      }).then((response) => {
        if (response.data.code === 0) {
          this.$message({
            message: response.data.msg,
            type: 'error'
          });
        } else {
          if (response.data.data.sOrder.is_pay === 1) {
            window.open("https://zxh1.xinzxing.cn/index/#/pages/info/info?id=" + this.orderId + "&token=" + this.token, "_blank");
          } else {
            this.$message({
              message: "您的订单未支付，或还在处理中，请稍后再试",
              type: 'error'
            });
          }
        }
      })
    },
    historyRecord() {
      this.$router.push({path: '/order'});
    },
    icp() {
      window.open("https://beian.miit.gov.cn/#/Integrated/index", "_blank");
    },
    jieshuo() {
      this.$message({
        message: "完成支付后解锁查看",
        type: 'error'
      });
    }
  }
}
</script>

<style>

.bg2 {
  width: 90px;
  height: 57px;
  position: absolute;
  right: 0;
  top: 41px;
  z-index: -1;
}

.bg4 {
  position: absolute;
  right: 0;
  top: 177px;
  width: 573px;
  height: 475px;
  z-index: -1;
}

.bg6 {
  position: absolute;
  top: 0;
  left: 0;
  width: 400px;
  height: 413px;
  z-index: -1;
}

.introduce {
  margin-bottom: 40px;
  background-color: #FFFFFF;
  padding: 40px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.introduce > div {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 50px;
}

.introduce > div > img {
  width: 50px;
  height: 50px;
  margin-right: 4px;
}

.introduce > div > div {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.introduce > div > div > p:nth-child(1) {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  margin: 0;
  text-align: left;
}

.introduce > div > div > p:nth-child(2) {
  font-size: 16px;
  color: #333333;
  margin: 0;
}

.icp {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #FFFFFF;
}

.icp > span,
.icp > div {
  margin-bottom: 10px;
}


.state1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.state2 {
  margin-top: 144px;
  margin-right: 108px;
  display: flex;
  flex-direction: column;
  margin-bottom: 84px;
}

.state2 > div {
  margin-bottom: 54px;
  position: relative;
}

.state2 > img {
  width: 556px;
  height: 138px;
}

.state2 > div > img:nth-child(1) {
  width: 600px;
  height: 151px;
}


.state2 > div > img:nth-child(2) {
  width: 155px;
  height: 48px;
  position: absolute;
  right: -60px;
}

.loginCard,
.payCard {
  display: inline-flex;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 0 32px;
  box-sizing: border-box;
  width: 456px;
  height: 370px;
  background: #FFFFFF;
  border-radius: 14px;
  margin-right: 100px;
  margin-top: 24px;
}

.loginCard > div:nth-child(1),
.payCard > div:nth-child(1) {
  background: rgba(251, 93, 21, 0.1);
  border-radius: 14px;
  padding: 12px 18px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.loginCard > div:nth-child(1) > img,
.payCard > div:nth-child(1) > img {
  width: 14px;
  height: 14px;
  margin-right: 9px;
}

.loginCard > div:nth-child(1) > span,
.payCard > div:nth-child(1) > span {
  font-size: 13px;
  color: #FB5D15;
}

input:focus {
  border: 0;
}

.loginCard > input {
  outline: 0;
  border: none;
  background: #F6F6F6;
  border-radius: 14px;
  font-size: 16px;
  padding: 18px 28px;
}

.loginCard > div:nth-child(4) {
  display: flex;
  flex-direction: row;
  font-size: 15px;
  color: #666666;
}

.loginCard > div:nth-child(4) > span:nth-child(2) {
  color: #0082F0;
}

.loginCard > div:last-child {
  height: 50px;
  background: linear-gradient(180deg, #00A3FF 0%, #6ECBFF 0%, #0059E6 100%);
  box-shadow: 0px 7px 28px 0px rgba(6, 144, 241, 0.3);
  border-radius: 11px;
  border-image: linear-gradient(180deg, rgba(181, 227, 255, 1), rgba(0, 106, 197, 1)) 1 1;
  text-align: center;
  line-height: 50px;
  position: relative;
  font-size: 18px;
  color: #FFFFFF;
}

.loginCard > div:last-child > div:nth-child(1) {
  background: linear-gradient(180deg, #FFA57C 0%, #FB560A 100%);
  border-radius: 18px 18px 0px 18px;
  left: 7px;
  padding: 0 12px;
  box-sizing: border-box;
  position: absolute;
  font-size: 13px;
  color: #FFFFFF;
  text-shadow: 0px 1px 4px rgba(0, 0, 0, 0.22);
  height: 26px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.loginCard > div:last-child > img:nth-child(3) {
  width: 42px;
  height: 70px;
  right: 40px;
  position: absolute;
  top: 16px;
}

.payCard > div:nth-child(2) {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 20px;
  color: #333333;
  justify-content: center;
}

.payCard > div:nth-child(2) > img {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

.payCard > div:nth-child(3) {
  font-size: 16px;
  color: #333333;
  margin-right: 13px;
  text-align: center;
}

.payCard > div:nth-child(4) {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.payCard > div:nth-child(4) > div:nth-child(1) {
  width: 100px;
  height: 100px;
  margin-right: 35px;
  margin-bottom: 30px;
}

.payCard > div:nth-child(4) > div:nth-child(1) > img {
  background-color: #fff;
  padding: 6px;
  box-sizing: border-box;
}

.payCard > div:nth-child(4) > div:nth-child(2) {
  margin-right: 18px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.payCard > div:nth-child(4) > div > div {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 120px;
  background: rgba(18, 105, 238, 0.04);
  border-radius: 3px;
  border: 1px solid #D9DADB;
  padding: 5px 0;
  box-sizing: border-box;
  font-size: 15px;
  color: #333333;
  justify-content: center;
  margin-bottom: 14px;
}

.payCard > div:nth-child(4) > div > div:last-child {
  margin-bottom: 0;
}

.payCard > div:nth-child(4) > div > div > img {
  width: 22px;
  height: 22px;
  margin-right: 8px;
}

.payCard > div:nth-child(5) {
  background: linear-gradient(180deg, #00A3FF 0%, #6ECBFF 0%, #0059E6 100%);
  box-shadow: 0 7px 28px 0 rgba(6, 144, 241, 0.3);
  border-radius: 11px;
  margin: 0 59px;
  height: 40px;
  line-height: 40px;
  font-size: 20px;
  color: #FFFFFF;
}

.payCard > div:nth-child(6) {
  font-size: 16px;
  color: #333333;
}

.getCode {
  background: #F6F6F6;
  border-radius: 14px;
  padding: 18px 28px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.getCode > p {
  margin: 0;
  width: 100px;
  font-size: 16px;
  color: #0082F0;
}

.getCode > input {
  font-size: 20px;
  outline: 0;
  border: none;
  background: #F6F6F6;
  font-size: 16px;
}

.state3 {
  margin-top: 80px;
  position: relative;
  margin-right: 94px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.state3 > img:nth-child(1) {
  width: 750px;
  height: 459px;
}

.state3 > img:nth-child(2) {
  width: 458px;
  height: 100px;
  position: absolute;
  left: 150px;
  bottom: 40px;
}
</style>
